const defaultInputProps = {
  dense: true,
  outlined: true,
  hideDetails: 'auto',
  // validateOnBlur: true,
};

const inputTextProps = {
  ...defaultInputProps,
};

const inputTextAreaProps = {
  ...defaultInputProps,
  autoGrow: true,
  counter: 1000,
  rows: 4,
};

const inputSelectProps = {
  ...defaultInputProps,
  menuProps: {
    offsetY: true,
  }
};

const alertProps = {
  type: 'info',
  border: 'top',
  outlined: true,
  color: 'info',
  class: {
    'my-0': true,
    'pb-2': true,
  },
}

const toolbarProps = {
  dark: true,
  dense: true,
  outlined: true,
  flat: true,
  rounded: true,
  color: 'primary',
};

export {
  inputTextProps,
  inputTextAreaProps,
  inputSelectProps,
  alertProps,
  toolbarProps,
};